import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';

export interface SiteInfo {
  siteId: string;
  name: string;
  logo: string;
}

export interface Sites {
  [key: string]: SiteInfo;
}

export const isAssetSaleEnabled = (projectSettings: ProjectSettings) => {
  return projectSettings?.assetSaleEnabled ?? false;
};

export const isRetiredBrand = (projectSettings: ProjectSettings, selectedDivisionCode: string) => {
  const retiredBrandList = projectSettings.retiredBrands ? JSON.parse(projectSettings.retiredBrands as string) : [];
  return Object.values(retiredBrandList).some((site: any) => site.siteId === `${selectedDivisionCode}Site`);
};

export const hideMyCreditPageSections = (projectSettings: ProjectSettings, isSoldAccount: boolean) => {
  if (isAssetSaleEnabled(projectSettings) && isSoldAccount) {
    return true;
  }
  return false;
};

export const showSoldAccountSection = (projectSettings: ProjectSettings, isSoldAccount: boolean) => {
  if (isAssetSaleEnabled(projectSettings) && isSoldAccount) {
    return true;
  }
  return false;
};
export const showActiveBrandSections = (projectSettings: ProjectSettings, selectedSite: string) => {
  if (isRetiredBrand(projectSettings, selectedSite) && projectSettings?.retiredBrandsEnabled) {
    return false;
  }
  return true;
};

export const hideMakeAPaymentButton = (projectSettings: ProjectSettings, isSoldAccount: boolean) => {
  if (isAssetSaleEnabled(projectSettings) && isSoldAccount) {
    return true;
  }
  return false;
};

export const hidePaymentGuardianSection = (projectSettings: ProjectSettings, isSoldAccount: boolean) => {
  if (isAssetSaleEnabled(projectSettings) && isSoldAccount) {
    return true;
  }
  return false;
};

export const convertRetriedBrandSites = (siteList: any, data?: Sites, includeRetiredBrands = true) => {
  const activeBrands = Object?.values(siteList)?.map((site: any) => ({
    name: site?.siteId,
    logo: site?.logo,
    isRetiredBrand: false,
  }));

  if (!includeRetiredBrands) {
    return activeBrands;
  }

  const retiredBrands = Object?.values(data || {})?.map((site) => ({
    name: site?.siteId,
    logo: site?.logo,
    isRetiredBrand: true,
  }));

  const merged = [...activeBrands, ...retiredBrands];

  return Array?.from(new Map(merged?.map((item) => [item?.name, item]))?.values());
};
